import useMedia from '../hooks/useMedia';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { Tag } from '../components';
import { PrimaryButton, CollapsableButton } from '../buttons';

const HeaderFormContainer = styled.div(({ theme: { mobile, errorColor, borderColor, cardColor }, hasErrors }) => ({
  borderRadius: 10,
  border: `1px solid ${hasErrors ? errorColor : borderColor}`,
  padding: '24px 32px',
  backgroundColor: cardColor,
  [`@media ${mobile}`]: {
    padding: 16,
  }
}));

const HeaderForm = ({
  buttonTitle,
  children,
  tags,
  mobileFormOpen,
  setMobileFormOpen,
  hasErrors,
  mobilePrefix,
  ...props
}) => {
  const { onMobile } = useMedia();

  return (
    <HeaderFormContainer hasErrors={hasErrors} {...props} >
      {onMobile && mobilePrefix}
      {onMobile && mobileFormOpen ? (
        <div>

          {tags.map(({ value, label}) => {

            const isBool = value === true;
            return (value ? (
              <Tag key={label}>
                {isBool ? label : `${label}:`}
                {!isBool && <strong>{value}</strong>}
              </Tag>
            ) : null)
          })}


        </div>
      ) : (
        children
      )}
      {onMobile && mobileFormOpen && (
        <CollapsableButton
          css={css`
            width: 256px;
            width: auto;
            margin: auto;
            padding-top: 8px;
            padding-bottom: 0;
          `}
          isOpen={!mobileFormOpen}
          onClick={() => setMobileFormOpen()}
          title={buttonTitle}
          hasErrors={hasErrors}
        />
      )}

      {onMobile && !mobileFormOpen && (
        <PrimaryButton css={{ marginTop: '40px' }} onClick={() => setMobileFormOpen()}>
          {buttonTitle}
        </PrimaryButton>
      )}
    </HeaderFormContainer>
  );
};

HeaderForm.propTypes = {
  buttonTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  mobileFormOpen: PropTypes.bool,
  setMobileFormOpen: PropTypes.func,
  hasErrors: PropTypes.bool,
};

HeaderForm.defaultProps = {
  mobileFormOpen: true,
};

export default HeaderForm;
